export class OwnerReview {

	ownerReviewId: number;
	action: string;
}
